import { Colors, CompactButton } from 'library';
import React from 'react';
import TeacherCardBaseHeader from 'parent-portal/providers/cards/shared/TeacherCardBaseHeader';
import { ITeacher } from 'models';
import { styled } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { WorkerAvatar } from 'parent-portal/providers/cards/shared/WorkerAvatar';

export default function PublicTeacherCardHeader({ worker }: { worker: ITeacher }) {
    function openSignUp() {
        window.open('/signup', '_blank');
    }

    return (
        <TeacherCardBaseHeader
            color={Colors.turquoise}
            worker={worker}
            leftHeaderComponent={
                <ImageContainer>
                    <WorkerAvatar src={worker.pictureUrl} width={160} height={160} />
                </ImageContainer>
            }
            middleHeaderComponent={<></>}
            rightHeaderComponent={
                <ButtonContainer>
                    <CompactButton
                        onClick={openSignUp}
                        buttonStyle={{
                            marginRight: 10,
                        }}
                        textStyle={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: 'auto',
                        }}
                    >
                        Request {worker.name}
                        <IconCircle>
                            <ChevronRight htmlColor={Colors.white} />
                        </IconCircle>
                    </CompactButton>
                </ButtonContainer>
            }
            sectionWidths={{
                left: '34%',
                middle: '0%',
                right: '66%',
            }}
        />
    );
}

const ImageContainer = styled('div')({
    position: 'absolute',
    top: -20,
    left: -20,
});

const IconCircle = styled('div')({
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: Colors.darkNavy,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 4,
});

const ButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: 50,
    paddingBottom: 50,
});
